import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/perguntaResposta`;
export const createPergunta = async (formBuilder) => {
  return await axios.post(`${httpUrl}/create`, formBuilder).then((response) => response);
};

export const getPergunta = async () => {
  return await axios.get(`${httpUrl}/list`).then((response) => response);
};

export const getPerguntaByIdRegistroAtendimento = async (idRegistroAtendimento) => {
  return await axios.get(`${httpUrl}/registro-atendimento/${idRegistroAtendimento}`).then((response) => response);
};

export const getPerguntaById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deletePergunta = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
